export default __webpack_public_path__ + "static/media/Dominia Teleport.19f5e154.PNG";